import React from "react";

import { ILesson } from "../../../state";
import GuidelineSidebar from "../../../molecules/teacher/GuidelineSidebar";

import styles from "./Guideline.module.scss";

export interface Props {
  lesson: ILesson | null;
  classListString: string;
  prevLessonId: number | null;
  nextLessonId: number | null;
  onChangeLesson: (lessonId: number) => void;
}

const Guideline: React.FC<Props> = ({
  lesson,
  classListString,
  prevLessonId,
  nextLessonId,
  onChangeLesson,
}) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.guidelineImages}>
        {lesson &&
          lesson.guideline_images.map((url, i) => (
            <div className={styles.imageContainer} key={i}>
              <img className={styles.image} src={url} alt={`guideline-${i}`} />
            </div>
          ))}
      </div>
      <GuidelineSidebar
        lesson={lesson}
        classListString={classListString}
        prevLessonId={prevLessonId}
        nextLessonId={nextLessonId}
        onChangeLesson={onChangeLesson}
      />
    </div>
  );
};

export default Guideline;
